/**
 * Dashboard footer with copyright and help links.
 */
import React from "react";
import { Divider, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { VText } from "form";

/**
 * Renders the footer only on the dashboard route.
 */
const Footer = () => {
  const { t } = useTranslation("common");

  const location = useLocation();

  return (
    location.pathname === "/dashboard" && (
      <div className="v-bg-body">
        <Divider className="bg-gray-200 dark:bg-gray-500" />
        <div className="w-10/12 mx-auto px-4 text-black py-10">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className="flex justify-between text-base">
                <VText color="secondary" div>
                  Ampela 2026 {t("All right reserved")}
                </VText>
                <div className="flex">
                  <a className="no-underline ml-4 text-black" href="#/">
                    <VText color="secondary">{t("Help")}</VText>
                  </a>
                  <a className="no-underline ml-4 text-black" href="#/">
                    <VText color="secondary">{t("Contact us")}</VText>
                  </a>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    )
  );
};

export default Footer;
